// extracted by css-extract-rspack-plugin
export default {"root":"LeT36a","button":"_suvfc","disabled":"IJHyCj"};